import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CopyAssetWizardEffectsV26 } from './effects';
import * as fromCopyAssetWizardV26 from './reducer';

export function provideCopyAssetWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromCopyAssetWizardV26.copyAssetWizardFeatureKey, fromCopyAssetWizardV26.reducer),
    provideEffects(CopyAssetWizardEffectsV26),
  ]);
}
